export const CAROLINO_PLAN_ORDER = [
  'basico',
  'essencial',
  'classico',
  'especial',
] as const;

export type CarolinoPlanId = (typeof CAROLINO_PLAN_ORDER)[number];

export const CAROLINO_PLAN_LABELS: Record<CarolinoPlanId, string> = {
  basico: 'Básico',
  essencial: 'Essencial',
  classico: 'Clássico',
  especial: 'Especial',
};

export function normalizeCarolinoPlanId(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function formatCarolinoPlanName(planoName: string): string {
  const id = normalizeCarolinoPlanId(planoName);
  return CAROLINO_PLAN_LABELS[id as CarolinoPlanId] ?? planoName;
}

export function isCarolinoPlanId(id: string | null | undefined): boolean {
  if (!id) return false;
  const normalized = normalizeCarolinoPlanId(id);
  return CAROLINO_PLAN_ORDER.includes(normalized as CarolinoPlanId);
}

function carolinoPlanSortIndex(id: string): number {
  const normalized = normalizeCarolinoPlanId(id);
  const idx = CAROLINO_PLAN_ORDER.indexOf(normalized as CarolinoPlanId);
  return idx === -1 ? CAROLINO_PLAN_ORDER.length : idx;
}

export function sortCarolinoPlans<T extends { id: string }>(items: T[]): T[] {
  return [...items].sort(
    (a, b) => carolinoPlanSortIndex(a.id) - carolinoPlanSortIndex(b.id)
  );
}

export function buildEmptyCarolinoPlans<
  T extends {
    id: string;
    name: string;
    products: unknown[];
    totalPrice: number;
    pricePerPerson: number;
  },
>(): T[] {
  return CAROLINO_PLAN_ORDER.map(id => ({
    id,
    name: CAROLINO_PLAN_LABELS[id],
    products: [],
    totalPrice: 0,
    pricePerPerson: 0,
  })) as T[];
}
